import React from 'react'
import {Button, Pane, PlusIcon} from "evergreen-ui";
import FilterPairRow from "./FilterPairRow";


export default function FloodFilterPanel({
    isFullInfo,
    constructor,
    onAddFilter,
    onDeleteFilter,
    onSelectDatasourceTypeForLevel,
    onSelectDatasourceTypeForRainfall,
    onSelectEntityForLevel,
    onSelectEntityForRainfall,
    onSelectCodeForLevel,
    onSelectCodeForRainfall
}) {

    const isStationSet = constructor.station.id !== -1

    return (
        <Pane>
            {
                !isFullInfo ?
                    <Pane marginBottom={25} marginTop={-40} verticalAlign={"center"}>
                        <Pane paddingTop={5} paddingRight={10}>
                            <Button
                                iconAfter={PlusIcon}
                                appearance={"primary"}
                                disabled={!isStationSet || constructor.filters.length >= 20}
                                onClick={() => onAddFilter()}
                            >
                                Новый тип источника
                            </Button>
                        </Pane>
                    </Pane> : <></>
            }

            {
                constructor.filters.map((pair, index) => <Pane>
                    <FilterPairRow isFullWindow={isFullInfo}
                                   constructor={constructor}
                                   canSelect={isStationSet && !isFullInfo}
                                   rowNum={index}
                                   possibleDatasourceTypes={constructor.station.sourcesTypes}
                                   onDeleteFilter={onDeleteFilter}
                                   onSelectDatasourceTypeForLevel={onSelectDatasourceTypeForLevel}
                                   onSelectDatasourceTypeForRainfall={onSelectDatasourceTypeForRainfall}
                                   onSelectEntityForLevel={onSelectEntityForLevel}
                                   onSelectEntityForRainfall={onSelectEntityForRainfall}
                                   onSelectCodeForLevel={onSelectCodeForLevel}
                                   onSelectCodeForRainfall={onSelectCodeForRainfall}
                        />
                </Pane>)
            }
        </Pane>

    )
}
